import React, { useState } from "react";
import { ConsultModal } from "../../components/ConsultModal";
import { useTranslation } from "react-i18next";
import "./styles.less";
import { Button } from "../../components/Button";

export const SolutionBuildIdaasBanner = (props) => {
  const { title, subtitle, subtitle2, extra } = props;

  const { t } = useTranslation();

  return (
    <div>
      <section className="solution-build-idaas-banner">
        <div className="solution-build-idaas-banner-warp">
          <div className="banner-img">
            <img
              src="//files.authing.co/authing-website/solution-build-idaas-banner.png"
              alt="authing idaas banner"
            />
          </div>
          <div className="ad-solution-banner">
            <div className="banner-text">
              <div className="title">{title}</div>
              <div className="subtitle">
                <div>{subtitle}</div> <div>{subtitle2}</div>
                <a
                  className="extra"
                  href="https://aws.amazon.com/cn/blogs/china/combining-authing-to-realize-identity-authentication-and-authorization-on-aws/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {extra}
                </a>
              </div>

              <Button
                className="solution-button"
                onClick={() => {
                  // setVisible(true);
                  window.open("https://www.authing.cn/authingform?fromTag=ad");
                }}
              >
                {t("solution.detail.button-consult")}
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* <ConsultModal {...{ visible, setVisible }} /> */}
    </div>
  );
};
